import { styled } from '@pata-app/themes';

export const HighlevelBenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.core.sizing[4]}px;
  padding: 70px 20px;
`;

export const BenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.core.sizing[4]}px;

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    flex-direction: row;
  }
`;
